import React, { useEffect } from "react";
import "../../assets/css/Thankyou.css";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/Thankyou.css";
import MainBanner from "../Banner/MainBanner";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const Thankyou = () => {
	const navigate = useNavigate();
	const  location_state  = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	
	return (
		<>
			<Header />
			<MainBanner name={"Thankyou"} />
			<section className="thankyou">
				<div className="container">
					<div className="happyShopping">
						<h3 className="font-30 fw-600 pb-4">Thank you for Shopping</h3>
						<div className="button-group">
							<button onClick={()=>{navigate('/all-plants')}} className="btn setButtonThank">Continue Shopping</button>
						</div>
					</div>
				</div>
			</section>

			<Footer />
		</>
	);
};

export default Thankyou;
